const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const URLMake = require("../../../shared/URLMake");
const SubscriptionSummary = require("./SubscriptionSummary");
const CheckoutUtil = require("../util/CheckoutUtil");
const Copy = require("../../office/data/CopyTable").getCheckoutConfirmCopy();
const OpsParentSubChange = require("../vault/OpsParentSubChange");
const Policies = require("../../office/Policies");
const AssetsUtil = require("../../core/util/AssetsUtil");
const Link = require("../../core/view/Link");
const Big = require("big.js");

const styles = require("../../office/checkout/styles/ConfirmSubmission.css");
const {getStudentRegistrationPage} = require("../../core/vault/OpsPage");

module.exports = createReactClass({
	displayName: "ConfirmSubscription",

	propTypes: {
		account: PT.object.isRequired,
	},

	getInitialState: function() {
		return {
			lastFinishedAccount: this.props.account.lastFinishedSCS,
		};
	},

	render: function() {
		const account = this.state.lastFinishedAccount;
		const {
			orderID,
			previousPlanType,
			planType,
			newStudentID,
			newStudentName,
			couponCode,
			priceInfo,
			coupon,
			changeWarningInfo,
			cannotCancel,
			changeType,
		} = account;

		const s = String.fromCharCode(160);

		const infoGroups = CheckoutUtil.renderInfoGroupsAccountFinished(account, {
			alwaysUseFullTitle: true,
			referenceID: orderID ? "B" + orderID : null,
		});
		const isBundle = planType === "bundle";

		const infoDivs = [];

		_.each(infoGroups, (infoGroup, i) => {
			const infoGroupDiv = _.map(infoGroup, (info, j) => {
				return (
					<div className={styles.info} key={"info" + j}>
						{info}
					</div>
				);
			});

			if (i > 0) {
				infoDivs.push(
					<div className={styles.infoGroupSpace} key={"space" + i} />
				);
			}

			infoDivs.push(
				<div className={styles.infoGroupContainer} key={"group" + i}>
					{infoGroupDiv}
				</div>
			);
		});

		const extraInfo = <div className={styles.infoContainer}>{infoDivs}</div>;

		let newStudentButton = null;
		if (newStudentID) {
			const setupLink = getStudentRegistrationPage(newStudentID);
			newStudentButton = (
				<Link className={styles.textLink} to={setupLink}>
					Click here to set up {newStudentName}
					's account.
				</Link>
			);
		}

		//If order, show normal order message. Otherwise, show subscription change message
		const topMessage = orderID ? Copy.success : Copy.subscriptionChange;

		const couponInfo = {
			code: couponCode,
			lastCouponCode: "",
		};

		let couponExtraInfo = {};
		if (coupon) {
			couponExtraInfo = {
				couponUsed: Big(priceInfo.totals.subtotal).eq(Big(0)),
				remainingBalance: Big(coupon.balance).minus(
					priceInfo.totals.couponApplied || 0
				),
			};
		}

		let upgradeInfo;
		if (_.get(this.props.account, "subChangeState.changeType") === "upgrade") {
			upgradeInfo = {
				previousType: previousPlanType,
				newType: planType,
				displayName:
					newStudentName ||
					OpsParentSubChange.getDisplayName(this.props.account),
			};
		}

		return (
			<div className={styles.main}>
				<div className={styles.title}>
					{"Thank you for your" + s + "order!"}
				</div>
				{newStudentButton}
				<div className={styles.subtext}>{topMessage}</div>
				<div className={styles.summaryImgContainer}>
					<SubscriptionSummary
						priceInfo={priceInfo}
						upgradeInfo={upgradeInfo}
						priceLoadStatus="done"
						needsShipping={isBundle}
						changeWarningInfo={changeWarningInfo}
						className={styles.orderSummary}
						extraInfo={extraInfo}
						showItemize={true}
						hideFinalButtons={true}
						hideLink={true}
						tabIndex={500}
						couponInfo={couponInfo}
						couponExtraInfo={couponExtraInfo}
					/>
					<img
						className={styles.sideGrok}
						alt="Fiona and Grok"
						src={AssetsUtil.getOfficeCharacter("happy-grok")}
					/>
					<img
						className={styles.sideFiona}
						alt="Fiona and Grok"
						src={AssetsUtil.getOfficeCharacter("happy-fiona")}
					/>
					<Policies
						subChangePlanType={planType}
						cannotCancel={cannotCancel}
						subChangeType={changeType}
						className={styles.policyText}
						titleClass={styles.bold}
					/>
					<img
						className={styles.happyImgB}
						alt="Fiona and Grok"
						src={AssetsUtil.getOfficeCharacter("happy-fiona-grok")}
					/>
				</div>
				<div className={styles.buttonContainer}>
					<Link className={styles.button} to={URLMake.forAccount()}>
						Back to Account
					</Link>
					{newStudentButton}
				</div>
			</div>
		);
	},
});
